import React, { useState, useEffect } from 'react';
import styles from './ShoppingCart.module.css';
import ProgressBar from './ProgressBar/ProgressBar';
import useTabTitle from '../Hooks/useTabTitle';
import { NavLink } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import OrderReview from './OrderReview/OrderReview';
import Address from './Address/Address';
import ConfirmOrder from './ConfirmOrder/ConfirmOrder';

const ShoppingCart = ({ cart, setCart }) => {
    const isMobile = (window.innerWidth <= 768) ? true : false;

    const steps = ["Revizuire comandă", "Adresa", "Confirmă comandă"];

    const [currentStep, setCurrentStep] = useState(0);

    const [deliveryAddress, setDeliveryAddress] = useState(
        {
            name: '',
            email: '',
            phone: '',
            address: '',
            city: '',
            postalCode: '',
            country: ''
        });

    const [billingAddress, setBillingAddress] = useState({
        name: '',
        email: '',
        phone: '',
        companyName: '',
        cui: '',
        address: '',
        city: '',
        postalCode: '',
        country: ''
    });

    const [useSameAddress, setUseSameAddress] = useState(true);

    useTabTitle('Coșul meu')

    useEffect(() => {
        // Se duce la începutul paginii
        window.scrollTo(0, 0);
    }, [currentStep]); // Se execută doar la prima încărcare a paginii

    return (
        <div className={styles.container}>
            {isMobile || <ProgressBar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} />}
            <div className={styles.content}>
                {
                    (currentStep == 0)
                        ? <OrderReview cart={cart} setCart={setCart} setCurrentStep={setCurrentStep} currentStep={currentStep} />
                        : (currentStep == 1)
                            ? <Address setCurrentStep={setCurrentStep} cart={cart}
                                deliveryAddress={deliveryAddress} setDeliveryAddress={setDeliveryAddress}
                                billingAddress={billingAddress} setBillingAddress={setBillingAddress}
                                useSameAddress={useSameAddress} setUseSameAddress={setUseSameAddress} />
                            : (currentStep == 2)
                                ? <ConfirmOrder setCurrentStep={setCurrentStep} cart={cart} setCart={setCart}
                                    deliveryAddress={deliveryAddress} billingAddress={billingAddress} useSameAddress={useSameAddress} />
                                : <OrderReview cart={cart} setCart={setCart} setCurrentStep={setCurrentStep} currentStep={currentStep} />
                }
            </div>
        </div>
    )
};

export default ShoppingCart;
